import { Button } from '@amore/ui/components/button'
import { CardTitle } from '@amore/ui/components/card'
import { MaterialsPanel } from '@amore/ui/components/materials-panel'
import { FileText, FolderOpen, NotebookPen, PencilLine, Plus } from 'lucide-react'
import { useCanEdit, useWedding } from '@/mock/store'
import { EmptyState } from '@/patterns/empty-state'

export function ReceptionMaterials({ onPreview }: { onPreview: (title: string) => void }) {
  const { reception } = useWedding()
  const canEdit = useCanEdit()
  return (
    <MaterialsPanel
      aria-label="Podklady a poznámky k jídlu a pití"
      header={
        <div className="flex items-center gap-2.5">
          <FolderOpen className="size-4 text-action" aria-hidden="true" />
          <CardTitle as="h2">Podklady a poznámky</CardTitle>
        </div>
      }
      files={
        <>
          <div className="flex flex-wrap items-center justify-between gap-2">
            <h3 className="text-sm font-semibold">Menu, nabídky a inspirace</h3>
            {canEdit ? (
              <Button
                appearance="outline"
                tone="neutral"
                size="sm"
                onClick={() => onPreview('Přidání podkladů připravujeme')}
              >
                <Plus className="size-3.5" aria-hidden="true" /> Přidat soubor
              </Button>
            ) : null}
          </div>
          {reception.documents.length ? (
            <ul className="divide-y divide-border">
              {reception.documents.map((document) => (
                <li key={document.id} className="flex min-w-0 items-center gap-3 py-4 first:pt-0">
                  <span className="grid size-10 shrink-0 place-items-center rounded-full bg-muted text-muted-foreground">
                    <FileText className="size-4" aria-hidden="true" />
                  </span>
                  <div className="min-w-0 flex-1 space-y-1">
                    <button
                      type="button"
                      onClick={() => onPreview('Náhled podkladů připravujeme')}
                      className="block max-w-full break-words text-left text-sm font-semibold text-action underline-offset-4 hover:underline focus-visible:outline-2 focus-visible:outline-ring"
                    >
                      {document.name}
                    </button>
                    <p className="text-xs text-muted-foreground">
                      PDF · {Math.max(1, Math.round(document.sizeBytes / 1000))} kB
                    </p>
                  </div>
                </li>
              ))}
            </ul>
          ) : (
            <EmptyState
              placement="inline"
              icon={<FolderOpen />}
              title="Všechno důležité po ruce"
              description="Zatím bez podkladů. Místo pro nabídku cateringu, menu z degustace nebo inspiraci."
            />
          )}
        </>
      }
      notes={
        <>
          <div className="flex min-h-9 items-center justify-between gap-2">
            <h3 className="flex items-center gap-2 text-sm font-semibold">
              <NotebookPen className="size-4 text-action" aria-hidden="true" /> Poznámky
            </h3>
            {canEdit ? (
              <Button
                appearance="ghost"
                tone="neutral"
                size="icon"
                aria-label="Upravit poznámky k jídlu a pití"
                onClick={() => onPreview('Úpravu poznámek připravujeme')}
              >
                <PencilLine className="size-4" aria-hidden="true" />
              </Button>
            ) : null}
          </div>
          <p className="break-words text-sm leading-7 whitespace-pre-line text-muted-foreground">
            {reception.notes ||
              'Domluvy z degustace, nápady a drobnosti, které nechcete zapomenout.'}
          </p>
        </>
      }
    />
  )
}
